"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSelectableItem = exports.getItemBackgroundColor = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../..");
const todayBorderCSS = ({ theme }) => (0, styled_components_1.css) `
    box-shadow: inset 0 1px 0 0 ${theme.colorControlBorderAccent};
    box-shadow: inset 0 -1px 0 0 ${theme.colorControlBorderAccent};
    box-shadow: inset -1px 0 0 0 ${theme.colorControlBorderAccent};
    box-shadow: inset 1px 0 0 0 ${theme.colorControlBorderAccent};
    box-shadow: inset 0 0 0 1px ${theme.colorControlBorderAccent};
`;
const getItemBackgroundColor = ({ selected, isHighlighted, theme }) => {
    if (selected) {
        return theme.colorHighlightDark;
    }
    if (isHighlighted) {
        return theme.colorHighlightNotification;
    }
    return 'transparent';
};
exports.getItemBackgroundColor = getItemBackgroundColor;
exports.StyledSelectableItem = styled_components_1.default.button `
    border: 0;
    outline: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 32px;
    height: 32px;
    box-sizing: border-box;
    padding-right: 8px;
    padding-left: 8px;
    font-size: ${helpers_1.FONT_SIZE_M};

    color: ${({ isCurrentMonth, theme }) => isCurrentMonth ? theme.colorTextMain : theme.colorTextSecondary};

    ${({ disabled }) => !disabled && `cursor: pointer;`}

    ${({ theme, disabled, selected }) => !disabled &&
    !selected &&
    (0, styled_components_1.css) `
            &:hover {
                background: ${theme.colorHighlightLight};
            }

            &:active {
                background: ${theme.colorHighlightDark};
            }
        `};

    background: ${exports.getItemBackgroundColor};

    ${({ disabled, theme }) => disabled &&
    (0, styled_components_1.css) `
            color: ${theme.colorTextLight};
            background: ${theme.colorBackgroundDisabled};
        `};

    border: ${({ isToday, showCurrentDate }) => isToday && showCurrentDate ? todayBorderCSS : '0'};
`;
//# sourceMappingURL=SelectableItem.styles.js.map